class HeaderBanner extends HTMLElement {
  constructor() {
    super();

    this.speed = parseInt(this.getAttribute("speed")) || 2000;
    this.swiper = null;
    this.sliderWrapper = null;
    this.progressBar = null;
  }

  connectedCallback() {
    this.sliderWrapper = this.querySelector(".swiper");
    this.progressBar = this.querySelector(".header-banner__progress--bar");

    if (!this.sliderWrapper) {
      console.error("Swiper wrapper not found in HeaderBanner");
      return;
    }
    if (!this.progressBar) {
      console.error("Progress bar not found in HeaderBanner");
      return;
    }
    if (typeof Swiper === "undefined") {
      console.error("Swiper library is not loaded.");
      return;
    }

    // Initialize Swiper
    this.initSlider();

    // Listen  events
    if (this.swiper) {
      this.swiper.on("slideChange", this.updateProgressBar.bind(this));
      this.swiper.on(
        "slideChangeTransitionEnd",
        this.resetProgressBar.bind(this)
      );
    }
  }

  initSlider() {
    this.swiper = new Swiper(this.sliderWrapper, {
      effect: "fade",
      slidesPerView: 1,
      spaceBetween: 0,
      speed: this.speed,
      loop: true,
      autoplay: {
        delay: this.speed,
        disableOnInteraction: false,
      },
    });
  }

  resetProgressBar() {
    const totalSlides = this.swiper.slides.length;
    const isLastSlide = this.swiper.realIndex === totalSlides - 1;
    if (!isLastSlide) return;
    this.progressBar.style.width = `${100 / totalSlides}%`;
  }

  updateProgressBar() {
    const totalSlides = this.swiper.slides.length;
    const percentage = ((this.swiper.realIndex + 1) / totalSlides) * 100;
    this.progressBar.style.width = `${percentage}%`;
  }
}

customElements.define("header-banner", HeaderBanner);
